import { fadedBrightThemeColor } from "@hilma/netina2all";
import { StationStatus } from "../types";
import { darkBlue } from "../constants";

export const getStationStatusColor = (status?: StationStatus | null): string => {
	switch (status) {
		case StationStatus.Open:
			return fadedBrightThemeColor;
		case StationStatus.Inactive:
			return darkBlue;

		default:
			return '';
	}
}